import { render } from "./Primary2.vue?vue&type=template&id=3b42a5ee&ts=true"
import script from "./Primary2.vue?vue&type=script&lang=ts"
export * from "./Primary2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Primary2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b42a5ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b42a5ee', __exports__)) {
    api.reload('3b42a5ee', __exports__)
  }
  
  module.hot.accept("./Primary2.vue?vue&type=template&id=3b42a5ee&ts=true", () => {
    api.rerender('3b42a5ee', render)
  })

}


export default __exports__